import { message } from 'antd';
import { getUser, findMenu, TokenMenu, getPartList, getPartAll } from "../utils/requestMenu"
import { DICT_KEY, getModel, refreshDict, setModel, ENV } from "../utils/constants";

const MODEL_KEY = DICT_KEY.SUPPLY_USER
const globalModel = {
    state: {
        userInfo: {
            orgId: "042001",
            orgName: "天路云卡张家口汽车销售有限公司",
            userName: undefined,
            userId: undefined
        },
        setting: {
            contactWeiChai: "400-618-3066",//联系潍柴
            contactUs: "0313-6218881",//联系我们
        },
        appCode: "",
        userMenu: [],
        loading: false,
        preview: {
            visible: false,
            __html: null
        },
    },
    reducers: {
        setUserInfo(state, payload) {
            state.userInfo = { ...state.userInfo, ...payload }
            setModel(MODEL_KEY, { ...state });
        },
        setAppCodes(state, payload) {
            state.appCode = payload
        },
        setUserMenu(state, payload) {
            state.userMenu = payload
            setModel(MODEL_KEY, { ...state });
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setPreview(state, payload = {
            visible: false,
            __html: null
        }) {
            // debugger
            state.preview = payload
        }
    },
    effects: () => ({
        async loadGetUser({ }, { }) {
            try {
                let res = await getUser()
                if (res && res.retCode === "200") {
                    // console.log("token过期了2")
                    this.setUserInfo(res.retData)
                    // this.setLoading(false)
                }
                return res
            } catch (error) {
                this.setUserInfo(null)
                this.setLoading(false)
                // console.log("获取用户信息失败")
                message.warning("获取用户信息失败")
                return error
            }
        },
        async loadUserMenu({ }) {
            await TokenMenu().then(res => {
                if (res && res.retCode === "200") {
                    let app = res.retData.find(item => {
                        if (item.appdetals.length > 0) {
                            return item.appdetals[0].appType === `${ENV === "TEST" ? "yh-scm-t" : "yh-scm"}`;
                        }
                    });
                    if (!app || app.appdetals.length === 0) {
                        this.setLoading(false);
                        this.setUserMenu([]);
                        return;
                    }
                    findMenu({
                        roleId: app.id,
                        appId: app.appdetals[0].id
                    }).then(res => {
                        // console.log(res)
                        if (res && res.retCode === "200") {
                            this.setUserMenu(res.retData)
                            this.setLoading(true);
                        } else {
                            message.warning("获取用户菜单异常")
                        }
                    })
                } else {
                    message.warning("获取用户角色失败")
                }
            })
        }
    }),
}
export default globalModel;